export const UPDATE_PCON_URL = 'UPDATE_PCON_URL';

export const updatePconUrl = (url) => ({
  type: UPDATE_PCON_URL,
  payload: {
    url,
  }
})
